<mat-card>
  <mat-card-content>
    <span>
      <strong>{{ zusatztermin.ZEITRAUMVON | gracefulDate: 'dd.MM.yyyy, HH:mm' }}</strong
      >&nbsp;
      {{ zusatztermin.INFOEINTRAGKURZ }}
    </span>
  </mat-card-content>
</mat-card>
